import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import { I18n } from "aws-amplify/utils";
import {useAuthenticator} from '@aws-amplify/ui-react';
import {Badge} from "primereact/badge";
import {UserContext} from "./app-context";
import {NotificationsPanel} from "./components/notifications/NotificationsPanel";

export const AppTopbar = (props) => {

    const authenticatedUserData = useContext(UserContext);

    const { signOut } = useAuthenticator((context) => [context.user]);

    let numnotif = 0;
    if (authenticatedUserData) {
        if (!authenticatedUserData?.email_verified) {
            numnotif++;
        }
        if (!authenticatedUserData?.phone_number_verified) {
            numnotif++;
        }
    }

    // Mirrors the visibility rules encoded in App.js's wrapperClass: on desktop the sidebar shows
    // unless staticMenuInactive, on mobile it's off-canvas unless mobileMenuActive. Not reactive to
    // a bare window resize, only to the next toggle - same tradeoff as App.js's own isDesktop(),
    // whose 992px breakpoint this intentionally matches.
    const sidebarExpanded = window.innerWidth >= 992
        ? !props.staticMenuInactive
        : props.mobileMenuActive;

    const profileLinkLabel = numnotif > 0
        ? `${I18n.get("profile")} - ${I18n.get("profile.pendingActionsCount").replace("{{count}}", numnotif)}`
        : I18n.get("profile");

    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">
                <img src={'assets/layout/images/cdm_logo.svg'} alt={I18n.get("logo.alt")}/>
            </Link>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}
                    aria-label={I18n.get("menu.toggle")} aria-expanded={sidebarExpanded} aria-controls="app-sidebar">
                <i className="pi pi-bars" aria-hidden="true"/>
            </button>

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}
                    aria-label={I18n.get("menu.mobile")} aria-expanded={!!props.mobileTopbarMenuActive} aria-controls="app-topbar-menu">
                <i className="pi pi-ellipsis-v" aria-hidden="true"/>
            </button>

            <ul id="app-topbar-menu" className={classNames("layout-topbar-menu lg:flex origin-top", {'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>
                {authenticatedUserData && authenticatedUserData.prenom && authenticatedUserData.nom &&
                    <li>
                        <span className="layout-topbar-title">
                            <h5>{`${authenticatedUserData.prenom} ${authenticatedUserData.nom}`}</h5>
                        </span>
                    </li>
                }
                <NotificationsPanel />
                <li>
                    <Link to="/profile" className="p-link layout-topbar-button" aria-label={profileLinkLabel} title={profileLinkLabel}>
                        <i className="pi pi-fw pi-user p-text-secondary p-overlay-badge" aria-hidden="true">
                            {numnotif > 0 && <Badge value={numnotif}></Badge>}
                        </i>
                    </Link>
                </li>
                <li>
                    <button className="p-link layout-topbar-button" onClick={signOut} aria-label={I18n.get("logout")} title={I18n.get("logout")}>
                        <i className="pi pi-fw pi-power-off" aria-hidden="true"/>
                    </button>
                </li>
            </ul>
        </div>
    );
}
